import { formatAmount } from "@/lib/utils/formatters";
import styles from "../../styles/applicationDetail.module.css";
import type { SignaturePaymentBalanceSectionsProps } from "../../types";

export function SignaturePaymentBalanceSections({
  tab,
}: SignaturePaymentBalanceSectionsProps) {
  const {
    applicationAllData,
    canEditApplication,
    showAccessFeeBalanceDue,
    showBalanceOwed,
    balanceOwedAmount,
    paymentFailedList,
    unfreezeReason,
    submittingUnfreeze,
    setUnfreezeReason,
    handleUnfreezePayment,
  } = tab;

  return (
    <>
      {showAccessFeeBalanceDue && applicationAllData && (
        <div className={styles.paymentLogBalanceSummary}>
          {applicationAllData.premium_paid ? (
            <strong className={styles.paymentLogBalanceSummaryItem}>
              Access Fee Paid: {formatAmount(applicationAllData.premium_paid)}
            </strong>
          ) : null}
          <strong className={styles.paymentLogBalanceSummaryItem}>
            Balance Due:{" "}
            {applicationAllData.balance_due
              ? formatAmount(applicationAllData.balance_due)
              : applicationAllData.default_invoice_amount
                ? formatAmount(applicationAllData.default_invoice_amount)
                : "$0.00"}
          </strong>
        </div>
      )}

      {showBalanceOwed && (
        <div
          className={styles.section}
          data-testid="application-signature-payment-tab-section-balance-owed"
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "10px 0",
            }}
          >
            <strong style={{ fontSize: "16px" }}>
              Balance Owed: {balanceOwedAmount}
            </strong>
          </div>
        </div>
      )}

      {canEditApplication && paymentFailedList.length >= 3 && (
        <div
          className={styles.section}
          data-testid="application-signature-payment-tab-section-unfreeze-payment"
        >
          <h2 className={styles.sectionTitle}>Unfreeze Payment</h2>
          <div className="space-y-3 max-w-xl">
            <p className="text-sm text-gray-600">Freeze payment reasons:</p>
            <ul className="list-decimal pl-5 text-sm space-y-1">
              {paymentFailedList.map((line, idx) => (
                <li key={idx} dangerouslySetInnerHTML={{ __html: line }} />
              ))}
            </ul>
            <label
              className="block text-sm font-medium text-gray-700"
              data-testid="application-signature-payment-tab-unfreeze-reason-label"
            >
              Unfreeze reason (required)
              <textarea
                className="mt-1 w-full border border-gray-300 rounded p-2 min-h-[64px]"
                value={unfreezeReason}
                data-testid="application-signature-payment-tab-unfreeze-reason-input"
                onChange={(e) => setUnfreezeReason(e.target.value)}
              />
            </label>
            <button
              type="button"
              className={styles.btnSmall}
              disabled={submittingUnfreeze || !unfreezeReason.trim()}
              data-testid="application-signature-payment-tab-unfreeze-payment-button"
              onClick={() => void handleUnfreezePayment()}
            >
              {submittingUnfreeze ? "Processing..." : "Unfreeze Payment"}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
